export const GAP_TONE_LABEL = {
  LOW: "Minor difference — perception is broadly consistent.",
  MEDIUM: "Moderate difference — worth clarifying in the next conversation.",
  HIGH: "Significant difference — requires a focused discussion.",
} as const;

export const RESPONSIBILITY_MAX_ROWS = 20;